import { combineReducers } from 'redux';

import {
  ROLES_GET_ALL_SUCCESS,
  USERS_GET_ALL_SUCCESS,
  ROLE_ADD_SUCCESS,
  USER_ROLE_UPDATE_SUCCESS,
  STAFF_INVITE_SUCCESS,
  STAFF_REMOVE_SUCCESS,
  INVITE_REQUESTS_GET_ALL_SUCCESS,
} from '../actions/actionTypes';

const USERS_INITIAL_STATE = {};
function usersReducer(state = USERS_INITIAL_STATE, action) {
  switch (action.type) {
    case USERS_GET_ALL_SUCCESS:
      return { ...action.payload };
    case STAFF_INVITE_SUCCESS:
      let newPending = state.pending;
      if (action.payload?.inviteObj) newPending = [action.payload.inviteObj].concat(state.pending);
      return {
        ...state,
        pending: newPending,
      };
    case STAFF_REMOVE_SUCCESS:
      const acceptedAfterRemove = state.accepted
        .map((user) => {
          if (user.userId === action.payload.id) {
            return null;
          } else {
            return {
              ...user,
            };
          }
        })
        .filter((item) => item !== null);
      return {
        ...state,
        accepted: acceptedAfterRemove,
      };
    case USER_ROLE_UPDATE_SUCCESS:
      const { userId, role } = action.payload;
      const newAccepted = state.accepted.map((user) => {
        if (user.userId === userId) {
          return {
            ...user,
            role,
          };
        } else {
          return {
            ...user,
          };
        }
      });
      return {
        ...state,
        accepted: newAccepted,
      };
  }
  return state;
}

const ROLES_INITIAL_STATE = {};
function rolesReducer(state = ROLES_INITIAL_STATE, action) {
  switch (action.type) {
    case ROLES_GET_ALL_SUCCESS:
      return { ...action.payload };
    case ROLE_ADD_SUCCESS:
      const newRole = action.payload && action.payload.length && action.payload[0];
      if (newRole) {
        return {
          ...state,
          [newRole.role]: newRole,
        };
      }
      return state;
  }
  return state;
}
const INVITE_REQUESTS_INITIAL_STATE = [];
function inviteRequestsReducer(state = INVITE_REQUESTS_INITIAL_STATE, action) {
  switch (action.type) {
    case INVITE_REQUESTS_GET_ALL_SUCCESS:
      return action.payload;
  }
  return state;
}

export default combineReducers({
  users: usersReducer,
  roles: rolesReducer,
  inviteRequests: inviteRequestsReducer,
});
